import { FETCH_EDIT_USER} from '../../actions/types'
const INITIAL_STATE = {
    data: [],
}
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_EDIT_USER:
            return { ...state, data: action.data }
       default:
            return state;
    }
}